import React from 'react'
import PropTypes from 'prop-types'
import { getIn } from 'formik'
import OriginSelectCenter from '~/components/common/SelectCenter'

const SelectCenter = ({
  form,
  field,
  onChange,
  onBlur,
  disabled,
  ...props
}) => (
  <OriginSelectCenter
    {...field}
    onChange={(newValue) => {
      onChange(newValue)
      form.setFieldValue(field.name, newValue)
    }}
    onBlur={() => {
      onBlur()
      form.validateField(field.name)
    }}
    error={
      !!getIn(form.touched, field.name) && !!getIn(form.errors, field.name)
    }
    helperText={
      getIn(form.touched, field.name) && getIn(form.errors, field.name)
    }
    disabled={disabled || !!form.values.__readOnly}
    {...props}
  />
)

SelectCenter.defaultProps = {
  onChange: () => {},
  onBlur: () => {},
  disabled: false,
}

SelectCenter.propTypes = {
  form: PropTypes.shape().isRequired,
  field: PropTypes.shape().isRequired,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
}

export default SelectCenter
